module.exports = __webpack_public_path__ + "static/media/menuExclusion.c4c97662.svg";